import { Directive, ElementRef, Input, OnChanges, SimpleChanges } from '@angular/core'

@Directive({
    selector: '[uiTableRowAttrs]',
    standalone: true
})
export class UiTableRowAttrsDirective implements OnChanges {
    @Input('uiTableRowAttrs') attrs: Record<string, string | null | undefined> | null | undefined = null

    private appliedKeys = new Set<string>()

    constructor(private host: ElementRef<HTMLElement>) {}

    ngOnChanges(_changes: SimpleChanges): void {
        const el = this.host.nativeElement
        const next = this.attrs ?? {}

        for (const key of this.appliedKeys) {
            if (!(key in next)) el.removeAttribute(key)
        }

        const newKeys = new Set<string>()
        for (const [key, value] of Object.entries(next)) {
            if (value == null || value === '') {
                el.removeAttribute(key)
            } else {
                el.setAttribute(key, value)
                newKeys.add(key)
            }
        }

        this.appliedKeys = newKeys
    }
}
